// extracted by mini-css-extract-plugin
module.exports = {"or":"CreateWithAI_or__3oXQc"};